import { IIssueCategory } from '../../../../types/resources';

export const getIssueCategoryOptions = (issueCategories: IIssueCategory[]) => {
  return issueCategories.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())).map((category) => ({
    value: category.id,
    text: category.name,
  }))
};
